import http from "@/services/http";
import { featureFlags } from "@/config/env";
import { mockManager } from "@/services/mock";
import { getSourceId } from "@/utils/constants";

export interface QueryQuestionsParams {
  brandId?: string;
  categoryId?: string;
  days?: number;
  startDay?: string; // 格式：2025-12-30
  endDay?: string; // 格式：2025-12-30
  metricType?: string;
  modelId?: string;
  qId?: string; // 问题ID
  page?: number;
  pageSize?: number;
  sourceId?: number; // 数据源ID：2=国内，3=国外
}

export interface QueryQuestionItem {
  taskId: string;
  qId: string;
  question: string;
  modelId?: string;
  modelName?: string;
  createTime?: number;
}

export interface QueryQuestionsResponse {
  code: number;
  message: string;
  data: {
    list: QueryQuestionItem[];
    total: number;
    page: number;
    pageSize: number;
  };
}

export const queryQuestionsApi = {
  /**
   * 获取问题列表
   * @param params 请求参数
   */
  async getQueryQuestions(
    params: QueryQuestionsParams
  ): Promise<QueryQuestionsResponse["data"]> {
    // 自动添加sourceId，如果没有指定则使用默认值
    const sourceId = params.sourceId ?? getSourceId();

    // 构建请求参数
    const requestParams: Record<string, any> = {
      ...params,
      sourceId,
    };

    // 移除undefined的参数
    Object.keys(requestParams).forEach((key) => {
      if (requestParams[key] === undefined) {
        delete requestParams[key];
      }
    });

    if (featureFlags.enableMock) {
      return await mockManager.getQueryQuestions(requestParams);
    }

    try {
      const response = await http.get<QueryQuestionsResponse>(
        "data/query-questions",
        {
          params: requestParams,
        }
      );

      return response.data.data;
    } catch (err) {
      console.error("Query questions API error:", err);
      return {
        list: [],
        total: 0,
        page: 1,
        pageSize: 20,
      };
    }
  },
};

export default queryQuestionsApi;
